import { Component, OnInit } from '@angular/core';
import { FqLoggerService } from '@frequence/ui-kit/fq-logger';

@Component({
	selector: 'app-root',
	styleUrls: [],
	template: `
		<div class="main">
			<router-outlet></router-outlet>
		</div>
	`
})
export class AppComponent implements OnInit {
	constructor(private logger: FqLoggerService) {
		this.logger.initialize();
	}

	ngOnInit(): void {}
}
